const pad = (value) => String(value).padStart(2, '0');

const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;
const DATE_TIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/;

const toValidDate = (value) => {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatLocalDate = (date) =>
  [date.getFullYear(), pad(date.getMonth() + 1), pad(date.getDate())].join('-');

export const parseDateInputValue = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return toValidDate(value);
  }

  const dateMatch = String(value).match(DATE_PATTERN);
  if (dateMatch) {
    const [, year, month, day] = dateMatch;
    return new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0, 0);
  }

  const parsed = toValidDate(value);
  if (!parsed) return null;

  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate(), 12, 0, 0, 0);
};

export const parseDateTimeLocalValue = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return toValidDate(value);
  }

  const dateTimeMatch = String(value).match(DATE_TIME_PATTERN);
  if (dateTimeMatch) {
    const [, year, month, day, hours, minutes] = dateTimeMatch;
    return new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hours),
      Number(minutes),
      0,
      0
    );
  }

  return toValidDate(value);
};

export const formatDateTimeLocalValue = (value) => {
  const date = parseDateTimeLocalValue(value);

  if (!date) return '';

  return `${formatLocalDate(date)}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatDateInputValue = (value) => {
  const date = parseDateInputValue(value);

  if (!date) return '';

  return formatLocalDate(date);
};

export const toIsoFromDateTimeLocal = (value) => {
  const date = parseDateTimeLocalValue(value);
  return date ? date.toISOString() : null;
};

export const toIsoFromDateInput = (value) => {
  const date = parseDateInputValue(value);

  if (!date) return null;

  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999
  ).toISOString();
};
